import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { ContextService } from "@apply4u/services/context-service";
import { ToasterMessageService } from "@apply4u/services/toaster-message.service";
import { IsAny, IsNotAny, IsNotZero, IsNullOrEmpty } from "@apply4u/shared/helpers/common/type-safe-helpers";
import { ConfirmationService } from '@apply4u/shared/components/confirmation-modal/confirmation.service';
import { ConfirmationMessages } from "@apply4u/shared/constant/messages/confirmation-messages";
import { RecommendationService } from "@apply4u/services/recommendation/recommendation.service";
import { RecommendedList } from "@apply4u/models/recommendation/recommended-list";
import { Recommendation } from "@apply4u/models/recommendation/recommendation";
import { Router } from "@angular/router";
import { ClickElementById } from "@apply4u/shared/helpers/common/common-helpers";
import { RecommendationMapping } from "@apply4u/models/recommendation/recommendation-mapping";

@Component({
  selector: 'recommendations-modal',
  templateUrl: './recommendations-modal.component.html',
  styleUrls: ['./recommendations-modal.component.css']
})
export class RecommendationsModalComponent implements OnInit, OnChanges {
  @Input() RecommendedId: number;
  @Input() RecommendationTypeId: number;
  @Output() RecommendationChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  RecommendedList: RecommendedList[] = [];
  NewRecommendationName: string;

  constructor(private contextService: ContextService,
    private toasterService: ToasterMessageService,
    private recommendationService: RecommendationService,
    private router: Router,
    private confirmService: ConfirmationService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (IsNotZero(changes['RecommendedId'].currentValue) && IsNotZero(this.RecommendationTypeId)) {
      this.LoadRecommendedList(changes['RecommendedId'].currentValue);
    }
  }

  LoadRecommendedList(recommendedId: number): void {
    if (this.contextService.IsUserLoggedIn && this.contextService.IsApply4UAdmin) {
      this.contextService.ShowListLoading();
      this.RecommendedList = [];

      this.recommendationService.GetRecommendedListAsync(recommendedId, this.RecommendationTypeId, this.contextService.LoggedInUserId).subscribe(result => {
        this.contextService.HideListLoading();
        this.RecommendedList = result;
      }, error => {
        this.contextService.HideListLoading();
        this.toasterService.ServerError();
      });
    }
  }

  OnRecommendationChange(id: number): void {
    if (IsNotZero(id) && IsAny(this.RecommendedList)) {
      let index = this.RecommendedList.findIndex(d => d.Id == id);

      if (this.RecommendedList[index].IsExist) {
        this.RemoveRecommendationMapping(id);
      }
      else {
        this.SaveRecommendationMapping(id);
      }
    }
  }

  RemoveRecommendationMapping(recommendationId: number) {
    this.recommendationService.DeleteByRecommendedIdAsync(recommendationId, this.RecommendedId, this.RecommendationTypeId).subscribe(result => {
      let index = this.RecommendedList.findIndex(d => d.Id == recommendationId);

      this.RecommendedList[index].IsExist = false;
      this.RecommendedList[index].Total -= 1;
      this.EmitRecommendationChanged();
      this.toasterService.Success("Removed from recommended list.");
    });
  }

  SaveRecommendationMapping(id: number) {
    if (this.RecommendationTypeId > 0 && this.RecommendedId > 0) {
      let recommendationMapping = new RecommendationMapping();
      recommendationMapping.RecommendationId = id;
      recommendationMapping.RecommendedId = this.RecommendedId;
      recommendationMapping.RecommendationTypeId = this.RecommendationTypeId;


      this.recommendationService.SaveRecommendationMappingAsync(recommendationMapping).subscribe(result => {
        let index = this.RecommendedList.findIndex(d => d.Id == id);
        this.RecommendedList[index].IsExist = true;
        this.RecommendedList[index].Total += 1;
        this.EmitRecommendationChanged();
        this.toasterService.Success("Saved to recommended list.");
      });
    } else {
      this.toasterService.Error("Something went wrong.");
    }
  }

  EmitRecommendationChanged(): void {
    this.RecommendationChange.emit(IsAny(this.RecommendedList.filter(d => d.IsExist)));
  }

  OnRecommendationRemove(id: number): void {
    this.confirmService.SetMessage(ConfirmationMessages.ConfirmationOnRemoveWishlist).OpenConfirmationDialogue(isConfirmed => {
      if (isConfirmed) {
        this.recommendationService.DeleteRecommendationAsync(id).subscribe(result => {
          if (IsAny(this.RecommendedList)) {
            this.RecommendedList = this.RecommendedList.filter(d => d.Id != id);

            this.EmitRecommendationChanged();

            this.toasterService.Success("Recommendation removed.");
          }
        });
      }
    });
  }

  CreateNewRecommendation(): void {
    if (IsNotAny(this.RecommendedList)) {
      this.RecommendedList = [];
    }

    if (IsNullOrEmpty(this.NewRecommendationName)) {
      this.toasterService.Error("List name is empty.");
    }
    else if (IsAny(this.RecommendedList.filter(d => d.Title.toLowerCase().trim() == this.NewRecommendationName.toLowerCase().trim()))) {
      this.toasterService.Error("List already exists with this name.");
    }
    else {
      let recommendation = new Recommendation();
      recommendation.Title = this.NewRecommendationName;
      recommendation.RecommendedByUserId = this.contextService.LoggedInUserId;

      this.recommendationService.SaveRecommendationAsync(recommendation).subscribe(result => {
        let recommendedList = new RecommendedList();
        recommendedList.Id = result;
        recommendedList.Title = recommendation.Title;
        recommendedList.Total = 0;

        this.RecommendedList.unshift(recommendedList);

        this.NewRecommendationName = "";
        this.toasterService.Success("New recommendation list created.");
      }, error => {
        this.toasterService.ServerError();
      });
    }
  }

  ViewAll() {
    ClickElementById("btnViewAllRecommendations");
    this.router.navigateByUrl("/dispatch-recommendations");
  }
}
